import { pickAvatarId, avatarById, avatarHex } from "./avatars";

const PRIZE_COLORS = { amber: "#f5b335", mint: "#34d8a8", coral: "#ff5a82", grape: "#b18cff", tang: "#ff9a5a", ice: "#dce8ff" };

function PrizeHat({ kind, color, size }) {
  const c = PRIZE_COLORS[color] || "#f5b335";
  const w = Math.max(24, Math.round(size * 0.5));
  return (
    <svg viewBox="0 0 40 30" width={w} className="absolute -top-1.5 right-0 drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]" aria-hidden="true">
      {kind === "crown" && (
        <g fill={c}>
          <circle cx="10" cy="12" r="5" /><circle cx="20" cy="9" r="5.5" /><circle cx="30" cy="12" r="5" />
          <rect x="6" y="12" width="28" height="10" rx="5" />
        </g>
      )}
      {kind === "cap" && (
        <g fill={c}>
          <path d="M6,20 A14,14 0 0 1 34,20 Z" />
          <rect x="30" y="17" width="12" height="5" rx="2.5" />
          <circle cx="20" cy="5" r="2.5" fill="rgba(255,255,255,0.6)" />
        </g>
      )}
      {kind === "party" && (
        <g>
          <polygon points="20,1 11,26 29,26" fill={c} />
          <circle cx="20" cy="2.5" r="3" fill="#f6efdd" />
        </g>
      )}
    </svg>
  );
}

export default function Avatar({ color = "amber", size = 40, config = null, prize = null, className = "" }) {
  const id = pickAvatarId(config || { legacy: color });
  const character = avatarById(id);
  const hex = avatarHex(color);
  return (
    <span
      data-testid={`avatar-${id}`}
      className={`relative inline-flex shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={`/avatars/${id}.png`}
        alt={`${character ? character.name : "Player"} avatar`}
        className="h-full w-full rounded-full object-cover"
        style={{ border: `2px solid ${hex}`, boxShadow: `0 0 14px ${hex}44` }}
      />
      {prize && prize.kind && <PrizeHat kind={prize.kind} color={prize.color} size={size} />}
    </span>
  );
}
